import React from 'react';
import { Route, Navigate, Routes } from "react-router-dom";

export const GuardedRoute = ({ children, auth, ...rest }) => {
    return (
        <Routes>
            <Route {...rest} element={
            auth === true
                ? children
                : <Navigate to='/' />
            } />
        </Routes>        
    )
}